import { apiRequest } from "../../api/apiRequest";
import { GET_ALL_USERS_LIST, GET_TEACHER_DETAILS, GET_USER_LIST, POST_LOGIN, POST_SIGNUP } from "../../utils/api";
import { SIGNUP_FAILURE, SIGNUP_SUCCESS, TEACHER_DETAILS_FAILURE, TEACHER_DETAILS_SUCCESS, USER_DETAILS_FAILURE, USER_DETAILS_SUCCESS, USERLIST_FAILURE, USERLIST_SUCCESS, USERS_LIST_FAILURE, USERS_LIST_SUCCESS } from "./auth.actionTypes";

export const signup = (payLoad) => async (dispatch) => {
  const result = await apiRequest("post", POST_SIGNUP, payLoad);

  if (result.success) {
    localStorage.setItem("access_token", result.data.access_token);
    dispatch({
      type: SIGNUP_SUCCESS,
      payload: { data: result.data },
    });
    return { success: true };
  }

  dispatch({
    type: SIGNUP_FAILURE,
    payload: { message: result.message },
  });
  return { success: false, message: result.message };
};

export const getUserList = () => async (dispatch) => {
  const result = await apiRequest("get", GET_USER_LIST);

  if (result.success) {
    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: USER_DETAILS_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const teacherDetails = (teacherID) => async (dispatch) => {
  const result = await apiRequest("get", `${GET_TEACHER_DETAILS}/${teacherID}`);

  if (result.success) {
    dispatch({
      type: TEACHER_DETAILS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: TEACHER_DETAILS_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const allUsersList = () => async (dispatch) => {
  const result = await apiRequest("get", `${GET_ALL_USERS_LIST}`);

  if (result.success) {
    dispatch({
      type: USERS_LIST_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: USERS_LIST_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};